import type { NextApiRequest, NextApiResponse } from 'next';

export interface BffErrorResponse {
  status?: number;
  data?: { error?: string } | null;
}

export const INVALID_ACCESS_TOKEN = 'invalid_access_token';
const REFRESH_SENTINEL = 'refreshed';

export function isInvalidAccessTokenResponse(bffResponse: BffErrorResponse | null | undefined): boolean {
  if (!bffResponse) return false;
  if (bffResponse.data?.error === INVALID_ACCESS_TOKEN) return true;
  return bffResponse.status === 401;
}

export function hasRefreshSentinel(req: NextApiRequest): boolean {
  return req.query[REFRESH_SENTINEL] === '1';
}

export function redirectToRefreshIfInvalidToken(
  req: NextApiRequest,
  res: NextApiResponse,
  bffResponse: BffErrorResponse | null | undefined,
): boolean {
  if (!isInvalidAccessTokenResponse(bffResponse)) return false;
  if (hasRefreshSentinel(req)) return false;

  const reqUrl = req.url || '/';
  const separator = reqUrl.includes('?') ? '&' : '?';
  const returnTo = `${reqUrl}${separator}${REFRESH_SENTINEL}=1`;

  const params = new URLSearchParams({ return_to: returnTo });
  res.redirect(307, `/api/auth/refresh?${params.toString()}`);
  return true;
}
